import '@vfde-brix/headline/dist/styles.css';

import { createHeadline } from '@vfde-brix/headline';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-headline');

for (let i = 0, x = elements.length; i < x; i += 1) {

    // traversing one up to get the container element
    const containerElement = elements[i].parentElement;

    createHeadline(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
